import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import Checkbox from '@/component/atoms/Checkbox/_Checkbox/_Checkbox'
import useRepository from '@/hooks/useRepository'
import { openLink } from '@/utils/common'

import { ContractModalService } from '../ContractModal.service'
import { S } from '../ContractModal.style'

export const ContractStep1 = () => {
  const service = useRepository(ContractModalService)
  const [goNextStepTrigged, setGoNextStepTrigged] = useState(false)
  const invalidAllChecked =
    goNextStepTrigged &&
    (!service.usageTerms.content.isFullyChecked ||
      !service.usageTerms.isValid ||
      !service.usageTerms.isDirty)

  useEffect(() => {
    service.usageTerms.isValid = service.usageTerms.content.isFullyChecked
    service.usageTerms.isDirty =
      service.usageTerms.content.isFullyChecked || service.usageTerms.content.isPartChecked
  }, [service.usageTerms.content.isFullyChecked || service.usageTerms.content.isPartChecked])
  return (
    <>
      <section className="modal-body">
        <ul className="modal-step-wrapper">
          <li className="modal-step active">step 1</li>
          <li className="modal-step">step 2</li>
        </ul>
        <header className="modal-body-header">
          <h2>스쿨플랫 이용 동의</h2>
          <strong>스쿨플랫 이용을 위해 약관 동의가 필요합니다.</strong>
        </header>
        {/* step1 */}
        <S.ModalContent className="open active">
          <header className="step-header">
            <div>
              <Checkbox
                text={<p className="step-header-title">아래의 약관에 모두 동의합니다.</p>}
                indeterminate={service.usageTerms.content.isPartChecked}
                checked={service.usageTerms.content.isFullyChecked}
                onChange={() => service.usageTerms.content.toggleAllCheck()}
              />
              {invalidAllChecked && (
                <p className="error-message" style={{ paddingLeft: 33 }}>
                  {service.usageTerms.errorMessage}
                </p>
              )}
            </div>
          </header>
          <section className="step-content">
            {service.usageTerms.content.toArr.map(({ id, value, link }) => {
              return (
                <div className="terms">
                  <Checkbox
                    text={value}
                    key={id}
                    checked={service.usageTerms.content.isChecked(id)}
                    onChange={() => service.usageTerms.content.toggleCheck(id)}
                  />
                  <_OldButton
                    width="fit-content"
                    height={30}
                    style={{ padding: '0 12px', fontSize: 12 }}
                    onClick={() => openLink(link)}
                    theme="individual"
                  >
                    자세히 보기
                  </_OldButton>
                </div>
              )
            })}
          </section>
        </S.ModalContent>
      </section>
      <S.Footer>
        <_OldButton
          theme="primary"
          width={144}
          style={{ fontWeight: 700 }}
          onClick={async (e) => {
            setGoNextStepTrigged(true)
            if (!service.usageTerms.content.isFullyChecked) {
              return
            }
            service.uiStore.goNextStep()
          }}
        >
          다음단계
        </_OldButton>
      </S.Footer>
    </>
  )
}

export default observer(ContractStep1)
